/**
 * Route for `publisher-vs-publisher-comparison-widget`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PublisherVsPublisherComparisonWidgetPage } from "../features/publisher-vs-publisher-comparison-widget/PublisherVsPublisherComparisonWidgetPage";

export const publisherVsPublisherComparisonWidgetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/publisher-vs-publisher-comparison-widget",
	component: PublisherVsPublisherComparisonWidgetPage,
});

export default publisherVsPublisherComparisonWidgetRoute;
